/* Import External Modules */
import React from 'react';

/* Import Local Modules */
import { ValueText } from "./DetailText.js";
import AttributeDetailRenderer from "./AttributeDetailRenderer.js";
import InlineEditor from "../../attribute/editor/InlineEditor.js";
import { jsx as _jsx } from "react/jsx-runtime";
const USAGE = 'detail';

/**
 * Renders geopoint attribute details.
 */
export default class GeoPointAttributeDetailRenderer extends AttributeDetailRenderer {
  /**
   * Gets the value component.
   */
  getValueComponent(values, valueStyle, obj, cxt, {
    valueVariant
  }) {
    const {
      editable
    } = cxt;
    const context = this.getContext(obj, cxt);
    if (this.detail.formatter) {
      context.formatter = this.detail.formatter;
    }
    return /*#__PURE__*/_jsx(InlineEditor, {
      usage: "detail",
      variant: valueVariant,
      editable: editable,
      attrName: this.name,
      object: obj,
      style: valueStyle,
      context: context,
      children: /*#__PURE__*/_jsx("div", {
        children: Array.isArray(values) && values.map(value => {
          return /*#__PURE__*/_jsx("div", {
            style: {
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'nowrap'
            },
            children: /*#__PURE__*/_jsx(ValueText, {
              style: valueStyle,
              variant: valueVariant,
              children: value
            })
          }, value);
        })
      })
    }, this.name);
  }
}